import {
	getCoreRowModel,
	getFacetedMinMaxValues,
	getFacetedRowModel,
	getFacetedUniqueValues,
	getFilteredRowModel,
	getPaginationRowModel,
	getSortedRowModel,
	useReactTable,
	type TableOptions,
} from '@tanstack/react-table'

type UseDataTableBaseProps<TData> = Omit<
	TableOptions<TData>,
	'pageCount' | 'rowCount' | 'getCoreRowModel'
>

export type UseDataTableProps<TData> = UseDataTableBaseProps<TData> &
	(
		| { pageCount: number; rowCount?: number }
		| { pageCount?: number; rowCount: number }
	)

export function useDataTable<TData>(props: UseDataTableProps<TData>) {
	const { columns, pageCount, rowCount, initialState, ...tableProps } = props

	const table = useReactTable({
		columns,
		initialState,
		pageCount,
		rowCount,
		defaultColumn: {
			...tableProps.defaultColumn,
			enableColumnFilter: false,
		},
		enableRowSelection: true,
		getCoreRowModel: getCoreRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFacetedRowModel: getFacetedRowModel(),
		getFacetedUniqueValues: getFacetedUniqueValues(),
		getFacetedMinMaxValues: getFacetedMinMaxValues(),
		manualPagination: true,
		manualSorting: true,
		manualFiltering: true,
		...tableProps,
	})

	return { table }
}
